import { assoc, curry, either, equals, isEmpty, isNil, pipe } from "ramda";
import { isBlank } from "../common/general";
import * as submissionReducer from "submission/submissionReducer";

const validateSubmissionFiles = curry(({ submissionFiles }, errors) => {
  const hasErrors = isBlank(submissionFiles);
  return hasErrors
    ? assoc("workFiles", ["validation_work_file_required"], errors)
    : errors;
});

const validateCoverFile = curry((workTypeId, { coverFile }, errors) =>
  equals(workTypeId, "ALBUM") && isEmpty(coverFile)
    ? assoc("coverFile", ["validation_work_file_required"], errors)
    : errors
);

export const validateWorkTypeId = curry((workTypeId, errors) =>
  either(isEmpty, isNil)(workTypeId)
    ? assoc("workTypeId", ["validation_work_type_id_required"], errors)
    : errors
);

export const validateUpload = curry((submissionState, fields) =>
  pipe(
    validateSubmissionFiles(submissionState),
    validateCoverFile(submissionReducer.getWorkTypeId(submissionState), fields),
    validateWorkTypeId(submissionReducer.getWorkTypeId(submissionState))
  )({})
);
